import { IconData, useIconRepo } from "../../data/icons";
import { Icon } from "./Icon";
import React from "react";
import { shuffled } from "../../lib/util";

export const IconGrid = (props: any) => {
    const repo = useIconRepo();

    // Don't render without data..
    if (repo.loading || !repo.repository) {
        return null;
    }

    // Cap icons in grid to 48 max until infinite scroll works :^)
    const icons: IconData[] = shuffled(repo.repository.flatMap(pack => pack.icons)).slice(0, 48);
    // const icons: IconData[] = drawSamplesFrom(sample, Math.min(48 * 8, sample.length)).map(icon => ({ ...icon }));

    return (
        <section className="max-w-6xl mx-auto px-4 sm:px-6 py-8 mb-8">

            <div
                id="icon-grid"
                className="max-w-6xl grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-4"
            >
                {icons.map(icon => <Icon key={icon.id} data={icon} />)}
            </div>

        </section>
    );
};

